import { render, staticRenderFns } from "./TypeYearlyReportTable.vue?vue&type=template&id=22009c6d&"
import script from "./TypeYearlyReportTable.vue?vue&type=script&lang=js&"
export * from "./TypeYearlyReportTable.vue?vue&type=script&lang=js&"
import style0 from "./TypeYearlyReportTable.vue?vue&type=style&index=0&id=22009c6d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports